import { AgentFilesPreview } from '@/components/projects'
import { useAgentDetailContext } from '@/hooks'

export function AgentFilesPage() {
  const { projectId, agent, parsedConfig, canReadMemory } = useAgentDetailContext()

  return (
    <div data-testid="agent-files-section">
      <AgentFilesPreview projectId={projectId} agent={agent} config={parsedConfig} canReadMemory={canReadMemory} />
    </div>
  )
}
